<template>
    <div id="main-container">

        <div>
            <!-- tabs -->
            <b-tabs content-class="mt-3">

                <!-- Trends -->
                <b-tab title="Trends" active>
                    <div id="trend-data-container">
                        
                        <!-- Trends Chart component  -->
                        <Trends :item="item" ref="Trends" />
                    </div>                    
                </b-tab>

                <!-- Liquid Circuit -->
                <!-- <b-tab title="Liquid Circuit">
                    <div id="liquid-circuit-container">
                        <LiquidCircuit :item="item" ref="LiquidCircuit" />
                    </div>

                </b-tab> -->
                <!-- Advanced Trends -->
                <b-tab title="Advanced Trends">
                    <div id="advanced-trends-container">
                        <AdvancedTrends :item="item" ref="AdvancedTrends" />
                    </div>
                </b-tab>
                
                <!-- Temperature -->
                <b-tab title="Temperature Data">
                    <div id="device-data-container">

                        <!-- loading spinner -->
                        <div v-if="!deviceDataLoaded" id="live-data-loading" style="text-align: center; margin-top: 200px;">
                            <div class="lds-facebook">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div>Loading real time device stats...</div>
                        </div>

                        <div v-if="deviceDataLoaded">
                            
                            <!-- ApexChart Realtime -->
                            <div id="chart-realtime">
                                <apexchart type="line" height="96%" ref="chart" :options="chartRealtimeOptions" :series="seriesRealtime"></apexchart>
                            </div>

                        </div>

                    </div>                    
                </b-tab>

            </b-tabs>
        </div>
    </div>
</template>

<script>
    /* Import required Chart library */
    import VueApexCharts from "vue-apexcharts";
    // import LiquidCircuit from "./Trends/LiquidCircuit.vue";
    import AdvancedTrends from "./Trends/AdvancedTrends.vue";
    import Trends from "./Trends/Trends.vue";
    var realtimeLRT = [];

    function resetRealtimeData() {
        // Alternatively, you can also reset the data at certain intervals to prevent creating a huge series 
        realtimeLRT = realtimeLRT.slice(realtimeLRT.length - 10, realtimeLRT.length);
    }

    export default {
        name: 'DeviceData',
        components: {
            apexchart: VueApexCharts,
            // LiquidCircuit,
            AdvancedTrends,
            Trends,
        },
        data: function () {
            return {
                /* Realtime Chart Setup */
                seriesRealtime: [{
                    name: 'Liquid Temp',
                    data: realtimeLRT.slice()
                }],
                chartRealtimeOptions: {
                    chart: {
                        id: 'realtime',
                        height: '100%',
                        width: '100%',
                        type: 'line',
                        // background: '#2b2c2c',
                        foreColor: '#373d3f',
                        animations: {
                            enabled: true,
                            easing: 'linear',
                            dynamicAnimation: {
                                speed: 500
                            }
                        },
                        toolbar: {
                            show: false
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    tooltip: {
                        theme: 'dark'
                    },
                    dataLabels: {
                        enabled: true
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    title: {
                        text: 'Realtime Device Temperature ℃',
                        align: 'center'
                    },
                    markers: {
                        shape: 'circle',
                        size: 2
                    },
                    xaxis: {
                        type: 'datetime',
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        title: {
                            text: "℃", rotate: 0
                        }
                    },
                    legend: {
                        show: false
                    },
                },
                /* End Realtime Chart Setup */

                CurrentTemp: null,
                FlowActual: null,

                deviceDataLoaded: false,

                realtimeIntervalID: null,
                resetDataIntervalID: null,

            };
        },
        props: ['item'],
        mounted: function () {

             this.seriesRealtime = [];
             this.realtimeLRT = [];

            var me = this;

            this.refreshData();

            /* Priodically refresh data (currently set to every 5 seconds) */
            this.realtimeIntervalID = window.setInterval(function () {
                /* Load data and attach to charts */
                me.refreshData();
                me.updateCharts();

            }, 5000)

            // every 60 seconds, we reset the data to prevent memory leaks
            this.resetDataIntervalID = window.setInterval(function () {
                resetRealtimeData();

                me.refreshData();
                me.updateCharts();

            }, 600000 * 60)

            this.refreshTrendDataIntervalID = setInterval(() => {
                if(this.refreshTrendDataActive) {
                    this.refreshTrendData()
                }
            }, 60000) // 1 min            
        },
        beforeDestroy() {

            realtimeLRT = [];
            clearInterval(this.realtimeIntervalID);
            clearInterval(this.resetDataIntervalID);
        },
        methods: {
            updateCharts() {
                this.seriesRealtime = [{ name: 'Liquid Temp', data: realtimeLRT }];
            },
            async refreshData() {

                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                var data = {
                    "endpoint": "/api/devices/" + this.item.id + "/data?mode=stream"
                };

                data = JSON.stringify(data);

                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        { headers: headers }
                    );

                    for (var i = 0; i < response.data.length; i++) {
                        var element = response.data[i]
                        
                        if (element[0].TagID == "analogs_lc_lrt_scaled") {
                            realtimeLRT.push([new Date(element[0].ConvertedLocalDateTime).toLocaleString('en-US', { timeZone: 'Australia/Melbourne' }), element[0].TagValue.toFixed(1)]);
                            this.CurrentTemp = element[0].TagValue; this.CurrentTemp = element[0].TagValue.toFixed(1);
                        }
                        if (element[0].TagID == "pids_lc_flow_pid_pv") this.FlowActual = element[0].TagValue.toFixed(1);
                    }

                    /*if (realtimeLRT.length >= 2) */this.deviceDataLoaded = true;

                } catch (error) {
                    console.log(error);
                }
            },
        }
    };
</script>

<style>
    #main-container {
        display: block;
    }

    #charts-container {
        display: block;
    }

    #device-data-container {
        display: flexbox;
    }

    #trends-chart {
        position: relative;
        margin: 0 !important;
        float: left;
        height: calc(100vh - 340px);
    }

    #wrapper {
        padding-top: 20px;
        padding-left: 10px;
        background: #fff;
        border: 1px solid #ddd;
        box-shadow: 0 22px 35px -16px rgba(0, 0, 0, 0.1);
        max-width: 650px;
        margin: 35px auto;
    }

    #chart-line {
        position: relative;
        margin-top: -40px;
    }

    #chart-realtime {
        min-width: 100% !important;
        max-width: 100% !important;
        position: relative;
        margin: 0 !important;
        float: left;
        height: calc(100vh - 340px);
    }

    #realtime-stats {
        float: right;
        display: block;
        padding-top: 10%;
        padding-right: 10%;
    }

    .numberCircle {
        width: 120px;
        line-height: 120px;
        border-radius: 50%;
        text-align: center;
        font-size: 32px;
        border: 2px solid #666;
    }

    .cold {
        color: #0d6efd;
    }

    .warm {
        color: mediumvioletred;
    }

    .plain {
        color: #666;
    }

    .blue {
        color: #0d6efd;
    }

    #trends-chart {
        min-height: auto !important;
        position: relative;
        min-width: 100% !important;
        margin: 35px auto;
        float: left;
    }

    #live-update-switch {
        position: absolute;
        right: 0;
        bottom: 0;
    }
</style>